// apps/web/src/api/services/visits.service.ts
import { HttpClient } from '../http-client';
import {
  ApiResponse,
  Visit,
  CheckInRequest,
  CheckOutRequest,
  ActiveVisitsData,
  VisitorVisitsData,
  DailyStatsData,
  VisitsHistoryResponse,
} from '@gym-management/shared';
import { AxiosResponse } from 'axios';

export class VisitsService extends HttpClient {
  async checkIn(visitorId: string): Promise<Visit> {
    const response: AxiosResponse<ApiResponse<Visit>> = await this.post('/api/visits/checkin', {
      visitor_id: visitorId,
    } as CheckInRequest);
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to check in');
  }

  async checkOut(visitId?: string, visitorId?: string): Promise<void> {
    const payload: CheckOutRequest = {};
    if (visitId) payload.visit_id = visitId;
    if (visitorId) payload.visitor_id = visitorId;
    const response: AxiosResponse<ApiResponse<void>> = await this.post(
      '/api/visits/checkout',
      payload
    );
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to check out');
    }
  }

  async getActiveVisits(page = 1, limit = 100): Promise<ActiveVisitsData> {
    const response: AxiosResponse<ApiResponse<ActiveVisitsData>> = await this.get(
      `/api/visits/active?page=${page}&limit=${limit}`
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to get active visits');
  }

  async getVisitorVisits(visitorId: string, page = 1, limit = 10): Promise<VisitorVisitsData> {
    const response: AxiosResponse<ApiResponse<VisitorVisitsData>> = await this.get(
      `/api/visits/visitor/${visitorId}?page=${page}&limit=${limit}`
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to get visitor visits');
  }

  async getDailyStats(date?: string): Promise<DailyStatsData> {
    const url = date ? `/api/visits/stats/daily?date=${date}` : '/api/visits/stats/daily';
    const response: AxiosResponse<ApiResponse<DailyStatsData>> = await this.get(url);
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to get daily stats');
  }

  async getAllVisits(
    page = 1,
    limit = 20,
    date?: string,
    search?: string,
    visitorId?: string // ✅ новый параметр
  ): Promise<VisitsHistoryResponse> {
    let url = `/api/visits?page=${page}&limit=${limit}`;
    if (date) url += `&date=${date}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (visitorId) url += `&visitor_id=${visitorId}`; // ✅ добавляем visitor_id
    const res = await this.get<ApiResponse<VisitsHistoryResponse>>(url);
    if (res.data.success && res.data.data) return res.data.data;
    throw new Error(res.data.message || 'Failed to load visits');
  }
}
